import { render, staticRenderFns } from "./HostingInstancesCard.vue?vue&type=template&id=3d8f646f&scoped=true"
import script from "./HostingInstancesCard.vue?vue&type=script&lang=js"
export * from "./HostingInstancesCard.vue?vue&type=script&lang=js"
import style0 from "./HostingInstancesCard.vue?vue&type=style&index=0&id=3d8f646f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8f646f",
  null
  
)

export default component.exports